import { Text } from 'platform-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import './spec-course-stub.scss';

interface Props {
    textId: string;
    values?: React.ComponentProps<typeof FormattedMessage>['values'];
}
export const SpecCourseStub = React.memo(({ textId, values }: Props) => (
    <div className="spec-course-stub">
        <Text id={textId} size={Text.SIZE.XL} type={Text.TYPE.MARKDOWN} values={values} />
    </div>
));
